import axios from 'axios';
import { Modal } from 'antd';


export const svc_filters = [ 
  {text: "Azure", value:"1"}, 
  {text: "AWS", value:"2"}, 
  {text: "SDN", value:"3"}, 
  {text: "WNMS", value:"4"}, 
  {text: "RESTCONF", value:"5"},
  {text: "NCP", value:"6"},
]
export const restypes = [ {text: "TEXT", value:"0"}, {text: "JSON", value:"1"}, {text: "XML", value:"2"}, ]
export const methods = [ {text: "GET", value:"0"}, {text: "POST", value:"1"}, ]

///////////////////////////////////////////////////////////////////////////

export const REST_URL="http://10.0.20.205/zrest/"
//export const REST_URL="http://localhost:8000/zrest/"

export function success(msg) {
  Modal.success({
    title: msg,
  });
}

export function info(msg) {
  Modal.info({
    title: msg,
  });
}

export function error(msg) {
  Modal.error({
    title: msg,
  });
}

export function success_to_move(msg, location) {
  Modal.success({
    title: msg,
    onOk() {
      window.location.replace(location);
    },
  })
}

export function success_on_close(msg, onClose) {
  Modal.success({
    title: msg,
    onOk() {
      onClose();
    },
  })
}

export function additem(_apiname, _uri, _owner, _svcmodel, _restype, _content, _method, _header, _param, _body, _prefer, onClose) {

  // 서버에 보내기
  let body = {
    apiname: _apiname,
    uri: _uri,
    owner: _owner,
    svcmodel: _svcmodel,
    restype: _restype,
    content: _content,
    method: _method,
    header: _header,
    param: _param,
    body: _body,
    prefer: _prefer
  }

  axios.post(REST_URL + 'additem', body)
    .then(response => {
      if (response.data.status === 1) {
        //success_on_close(response.data.msg, onClose);
        success_to_move(response.data.msg, "/");
      } else {
        error(response.data.msg);
      }
      console.log('additem', response.data);
    })
}

export function moditem(_myid, _apiname, _uri, _owner, _svcmodel, _restype, _content, _method, _header, _param, _body, _prefer, onClose) {

  // 서버에 보내기
  let body = {
    myid: _myid,
    apiname: _apiname,
    uri: _uri,
    owner: _owner,
    svcmodel: _svcmodel,
    restype: _restype,
    content: _content,
    method: _method,
    header: _header,
    param: _param,
    body: _body,
    prefer: _prefer
  }
  //console.log("_myid", _myid);
  
  axios.post(REST_URL + 'moditem', body)
    .then(response => {
      if (response.data.status === 1) {
        //success_on_close(response.data.msg, onClose);
        success_to_move(response.data.msg, "/");
      } else {
        error(response.data.msg);
      }
      console.log('moditem', response.data);
    })
}

export function build(onClose) {

  // 서버에 보내기
  let body = {
  }

  axios.post(REST_URL + 'build', body)
    .then(response => {
      if (response.data.status === 1) {
        //success_on_close(response.data.msg, onClose);
        success_to_move(response.data.msg, "/");
      } else {
        error(response.data.msg);
      }
      console.log('build', response.data);
    })
}

export function delitem(ids, onClose) {

  // 서버에 보내기
  let body = {
    ids
  }

  axios.post(REST_URL + 'delitem', body)
    .then(response => {
      if (response.data.status === 1) {
        //success_on_close(response.data.msg, onClose);
        success_to_move(response.data.msg, "/");
      } else {
        error(response.data.msg);
      }
      console.log('delitem', response.data);
    })
}

